<template>
  <div style="display: inline-block;">
    <span @click="show()" id="addmonitor">
      <slot></slot>
    </span>
    <el-dialog top="0vh" v-if="dialogFormVisible" class="el-dialog-sm custom-width-dialog-900" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%">
      <h2 style="text-align: center;margin-bottom:30px;">创建监控</h2>
      <Monitor mode="createNew" :expressList="expressList" :merchants="merchants" @submit="submitHandler"></Monitor>
    </el-dialog>
  </div>
</template>

<script>
import { API_HOST, FILE_HOST,SPEC_MAPPER } from '../../../services/constant.js'
import api from '../../../services/api.js'
import Monitor from './MonitorBody.vue'
let _ = require('lodash')

export default {
  name: 'AddMonitor',
  components: {
    Monitor:Monitor,
  },
  props: ['merchants','expressList'],
  data() {
    return {
      ticket:{},
      isSubmitting:false,
      dialogFormVisible:false
    }
  },
  async mounted() {
    
  },
  methods: {
    show () {
      this.dialogFormVisible = true
    },
    async submitHandler(ticket){
      this.isSubmitting=true
      let p = JSON.parse(JSON.stringify(ticket))
      p.monitor_start_time=this.$moment(p.monitor_start_time).format('YYYY-MM-DD HH:mm:ss')
      let res = await api.addMonitor(this,p)
      this.isSubmitting=false
      if(res.body.status=='ok'){
        this.dialogFormVisible = false
        this.$store.commit('updateMessageDialog', {visible:true,message:'监控创建成功'})
        this.$emit('fetchTicket')
      }
    },  
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/orders/monitor/AddMonitor.vue